import Swiper from 'swiper';
//выбор таба
[].forEach.call(document.querySelectorAll('.tab__menu-item'), function tabMenu(el) {
    el.addEventListener('click', function tabMenuEl(event) {
        const tab = event.currentTarget.getAttribute('data-tab');

        event.currentTarget.closest('.tab').querySelectorAll('.tab__menu-item').forEach((item) => {
            item.classList.remove('active')
        });
        event.currentTarget.closest('.tab').querySelector('.tab__menu-item[data-tab="'+tab+'"]').classList.add('active');

        event.currentTarget.closest('.tab').querySelectorAll('.tab__content-item').forEach((item) => {
            item.classList.remove('active')
        });
        event.currentTarget.closest('.tab').querySelector('.tab__content-item[data-tab="'+tab+'"]').classList.add('active');
    })
});
let tabMenuMobSlider = null;
//меню табов на мобиле
function tabMenuMob() {
    let width = document.body.clientWidth;

    if(width <= 1170) {
        tabMenuMobSlider = new Swiper(".tab__menu", {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false
        });
    }
    else {
        if(tabMenuMobSlider) {
            tabMenuMobSlider.destroy(false, true);
        }
    }
    document.querySelectorAll('.tab__menu-item').forEach((item) => {
        item.style.width = item.offsetWidth;
    });
}

window.addEventListener("resize", function resize(){
    tabMenuMob()
});
window.addEventListener("load", function load(){
    tabMenuMob()
});
//меню табов на мобиле